import {moment} from 'moment';
import * as ko from "knockout";
import {AbstractParameter, IAbstractParams} from "./AbstractParameter";
import {IDynamicVariableTextInputParams} from "../../../../../dynamic-variable/index";
import {nsForm} from "../../../../nsForm";
import {INPUT_DATE_FORMAT} from "../../../../../../constants";
import DATE_FORMAT = nsForm.DATE_FORMAT;
import dateHtml from './date.html?raw';

export let template = dateHtml;

type TMode = 'dynamic' | 'date';

export class viewModel extends AbstractParameter {
    private dateValue: KnockoutObservable<string | null> = ko.observable(null);
    private inputType: KnockoutObservable<TMode | null> = ko.observable(null);

    constructor(protected override params: IAbstractParams) {
        super(params);
        this.kosub.subscribe(this.dateValue, dateValue => {
            const m = moment(dateValue, INPUT_DATE_FORMAT, true);
            if (m.isValid()) {
                this.parameter.val(m.format('DD.MM.YYYY'));
            } else {
                this.parameter.val(null);
            }
        })
        this.kosub.subscribe(this.inputType, inputType => {
            if (inputType == 'date') {
                const m = moment(this.parameter.val(), DATE_FORMAT, true);
                if (m.isValid()) {
                    this.dateValue(m.format(INPUT_DATE_FORMAT));
                } else {
                    this.dateValue(null);
                }
            }
        })
        let inputType: TMode;
        const isDateFormat = moment(this.parameter.val(), DATE_FORMAT, true).isValid();
        if (isDateFormat) {
            inputType = 'date';
        } else {
            inputType = 'dynamic';
        }
        this.inputType(inputType);
    }

    protected getParams(): IDynamicVariableTextInputParams {
        return {
            canOpenInDialog: false,
            expression: this.parameter.val,
            objectTypeId: this.parameter.objectTypeId,
            objectTypeIds: this.parameter.objectTypeIds,
            placeholder: this.getPlaceholder(),
            dynamicSupport: false,
            attr: {type: 'search'},
        }
    }

}
